// Výhody Premium — jeden seznam pro stránku Premium i upoutávku na úvodní
// stránce, ať si nemůžou odporovat.
//
// Anočine je od 7. 10. 2026 obyčejná karta na KONCI. Do té doby byla první
// a zvětšená („hero"), protože 16. 8. 2026 ji hráč přehlédl; ukázalo se ale,
// že pro hráče Přihořívá tak důležitá není. `anocine` = smí se nabízet
// (ANOCINE_BENEFIT: česky a jen s nasazenou druhou hrou).
export function premiumBenefitRows(anocine) {
  return [
    { e: "🔥", k: "mega" },
    { e: "🏆", k: "groups" },
    { e: "▶️", k: "resume" },
    { e: "📅", k: "archive" },
    { e: "👥", k: "friends" },
    ...(anocine ? [{ e: "anocine", k: "anocine" }] : []),
  ];
}
